// Fixed-size container for a Recharts chart. Pair with `initialDimension` on the
// ResponsiveContainer so its first render measures positive dims (no width(-1) warning).
export default function ChartFrame({ className, children }) {
  return <div className={className}>{children}</div>;
}
